import HanhTrangSoCourseAPI from '@/apis/business/MISAStore/hanhtrangso-course-api.js'

export default {

  namespaced: true,

  state: {
    listHanhTrangSoCourses: [], // Danh sách học liệu của I Giáo dục
    totalExerciseHanhTrangSo: 0 // Số lượng học liệu của I Giáo dục
  },

  getters: {},

  mutations: {
    /**
     * set Count Course
     * CreateBy: VHSON 24.09
     */
    setTotalCount (state, totalExerciseHanhTrangSo) {
      state.totalExerciseHanhTrangSo = totalExerciseHanhTrangSo
    },

    /**
     * set list Course
     * CreateBy: VHSON 24.09
     */

    setHanhTrangSoCourse (state, listHanhTrangSoCourses) {
      state.listHanhTrangSoCourses = listHanhTrangSoCourses
    }
  },

  actions: {
    /**
     * Lấy danh sách học liệu của Hanh Trang So
     * @author VHSon
     * @param {*} textSearch
     * @param {*} gradeID
     * @param {*} subjectID
     * @param {*} sourceType
     * @returns
     */
    getlistHanhTrangSoCourse (context, courseParams) {
      return new Promise((resolve, reject) => {
        HanhTrangSoCourseAPI.getAsync(
        `/hanhtrangso-courses?textSearch=${courseParams.textSearch}` +
          `&gradeID=${courseParams.gradeID}` +
          `&subjectID=${courseParams.subjectID}` +
          `&takeCharge=${courseParams.takeCharge}` +
          `&pageIndex=${courseParams.pageIndex}` +
          `&pageSize=${courseParams.pageSize}`
        )
          .then((res) => {
            context.commit('setHanhTrangSoCourse', res?.Data)
            context.commit('setTotalCount', res.Data?.Total)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
